// @ts-check
import { decamelizeKeys } from 'humps';
import api from 'utils/api';
import { cleanCamelHash } from 'utils/questionnaireUtils';
import { SubmissionError } from 'utils/reduxFormWrapper';

const errorsFromQuestionnaireSubmit422 = response => {
  const { data } = response;
  if (data.questionnaireErrors instanceof Array) {
    const formErrors = data.questionnaireErrors.reduce(
      (acc, question) => ({
        ...acc,
        [cleanCamelHash(question.prompt)]: question.error,
      }),
      {}
    );
    return formErrors;
  } else {
    return { _error: 'Please check for omissions.' };
  }
};

export function fetchQuestionnaire(url) {
  return api.get(url).then(response => response.data);
}

export function saveQuestionnaire(url, formValues) {
  return api
    .putWithoutDefaultRejectionHandling(url, {
      referral_questionnaire_response: decamelizeKeys(formValues),
    })
    .then(undefined, error => {
      const { response } = error;
      if (response && response.status === 422) {
        const formErrors = errorsFromQuestionnaireSubmit422(response);
        throw new SubmissionError(formErrors);
      } else {
        return error.defaultRejectionHandler(response);
      }
    });
}
